<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<template>
  <div v-if="is_run_cube_valid">
    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
        <div class="body-2 font-weight-bold nav nav-tabs">
          <li class="">
            <a class="pt-1"
              >{{
                $store.state.tradeData.report_selections.filter(
                  v => v.value === $store.state.tradeData.report_selection,
                )[0]['text']
              }}
              <v-icon
                @click="element2clipboard('mp1c-graphs')"
                style="float: left"
                data-html2canvas-ignore
                class="mr-2 white--text"
                >mdi-camera
              </v-icon>
              <help-link help_id="9" style="float: right" />
            </a>
          </li>
        </div>
      </v-flex>
    </v-layout>
    <div class="tab-content">
      aaa
      <div class="tab-pane active white" id="mp1c-graphs">
        <v-container
          fluid
          v-if="
            $store.state.tradeData.report_selection ===
              $store.state.tradeData.report_selections[0]['value']
          "
        >
          <v-layout class="justify-space-around align-center black--text\" row>
            <v-flex class="xs12 sm12 md12 lg6 xl3">
              <HistImpexpgraphTmMp1c
                class="d-flex justify-center"
              ></HistImpexpgraphTmMp1c>
            </v-flex>

            <v-flex class="xs12 sm12 md12 lg6 xl3">
              <histImpexpGraphTmTotalMp1c
                class="d-flex justify-center"
              ></histImpexpGraphTmTotalMp1c>
            </v-flex>

            <v-flex class="xs12 sm12 md12 lg6 xl3">
              <total-imports-exports-mp1c
                class="d-flex justify-center"
              ></total-imports-exports-mp1c>
            </v-flex>

            <v-flex class="xs12 sm12 md12 lg6 xl3">
              <trade-deficit-mp1c class="d-flex justify-center"></trade-deficit-mp1c>
            </v-flex>
            <v-flex class="xs12 sm12 lg12 ml-5 mr-8 mb-9 mt-12">
              <reoFrontendTable cube_name="cube_HS6_Code"></reoFrontendTable>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import totalImportsExportsMp1c from '@/components/trade-dsm-application/graphs/mp1c/total-imports-exports-mp1c';
import histImpexpGraphTmTotalMp1c from '@/components/trade-dsm-application/graphs/mp1c/hist-impexp-graph-tm-total-mp1c';
import HistImpexpgraphTmMp1c from '@/components/trade-dsm-application/graphs/mp1c/hist-impexpgraph-tm-mp1c';
import tradeDeficitMp1c from '@/components/trade-dsm-application/graphs/mp1c/trade-deficit-mp1c';

import helpLink from '@/components/application-level/help-system/help-link';
import reoFrontendTable from '@/components/trade-dsm-application/result-components/reo_table/reo-frontend-table';

export default {
  name: 'DSMMP1CGraphs',
  data: () => ({}),

  components: {
    totalImportsExportsMp1c,
    histImpexpGraphTmTotalMp1c,
    HistImpexpgraphTmMp1c,
    tradeDeficitMp1c,
    helpLink,
    reoFrontendTable,
  },
};
</script>

<style scoped>
.iconPM {
  animation: blink 3s ease-in infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
